// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 639) return "static/chunks/639.bd4f808688c9509c.js";
	if (chunkId === 966) return "static/chunks/64abf602.a771ea499ba99da1.js";
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 426 ? "bc0cb038" : chunkId) + "-" + {"426":"21caaa3a2ceee3e2","557":"06132ea8630cf71f","888":"e55c4f99aa0f71de"}[chunkId] + ".js";
};